import { ModelClass } from '@mathquis/modelx/lib/types/collection';
import ApiModel       from '@widesk-core/models/ApiModel';
import ApiCollection  from '@widesk-core/models/ApiCollection';
import useCollection  from '@widesk-core/hooks/useCollection';

export default function <M extends ModelClass<ApiModel>>(modelClass: M, fetch = false) {
	return useCollection(() => new ApiCollection(modelClass), fetch) as ApiCollection<InstanceType<M>>;
}
